<template>

</template>
<script>
export default {
  name: 'LogOut',
  data() {
    return {}
  },
  created() {
    this.logout();
  },
  methods: {
    async logout() {
      try {
        const logoutResp = await this.$axios.get('/user/logout')
        if (logoutResp.status === 200 || logoutResp.status === 302) {
          console.log("logout resp error: ", logoutResp)
        } else {
          console.log("logout resp error: ", logoutResp)
        }
      } catch (e) {
        console.log("请求退出错误：", e);
      } finally {
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        const url = window.location.href;
        if (url.includes("dev.familypro")) {
          window.location.href = 'https://dev.familypro.io/';
        } else {
          window.location.href = 'https://familypro.io/';
        }
      }

      // setTimeout(() => {
      //   const url = window.location.href;
      //   if (url.includes("dev.familypro")) {
      //     window.location.href = 'https://dev.familypro.io/';
      //   } else {
      //     window.location.href = 'https://familypro.io/';
      //   }
      // }, 500);

      // this.$router.push({path: "/index"});
      // window.location.href = 'https://familypro.io/';
    }
  }
}

</script>
<style scoped>

</style>